import { SuppressedAlarm } from 'data/alarm/alarm.types';
import { AuditDetails, WithAuditDetails } from 'data/types';
import {
  AuditService,
  AuditActionType,
  getAuditDetails
} from 'shared/userAudit/audit-constants';

export default function getDeletedSuppressedAlarmPayload(
  auditEnabled: boolean,
  userId: string,
  userName: string,
  alarms: SuppressedAlarm[]
): WithAuditDetails<SuppressedAlarm[]> {
  const ret: WithAuditDetails<SuppressedAlarm[]> = {
    data: alarms
  };
  const fieldInfo: any = [];
  fieldInfo.push({
    field: 'suppressedAlarms',
    before: '',
    after: alarms
  });

  if (auditEnabled) {
    const auditDetails = getAuditDetails(
      auditEnabled,
      userId,
      userName,
      fieldInfo,
      userName,
      AuditService.ALARM,
      AuditActionType.ALARM_SUPPRESS
    ) as AuditDetails;
    ret.auditDetails = auditDetails;
  }
  return ret;
}
